<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <b-row>
            <b-col cols="12">
                <FormInput label="Nombre" type="text" name="nombre" id="nombre" rules="required" v-model="grupoLocal.nombre" :disabled="loading" />
            </b-col>
            <b-col cols="12">
                <label for="descripcion">Descripción</label>
                <textarea   
                    id="descripcion"
                    v-model="grupoLocal.descripcion"
                    class="form-control"
                    rows="5"
                    :disabled="loading"
                ></textarea>
            </b-col>
            <b-col cols="12" class="text-right mt-3">
                <Button type="submit" :disabled="loading">Continuar</Button>
            </b-col> 
        </b-row>
    </ValidationObserver>
</template>

<script>
    export default {
        props: {
            grupo: {
                type: Object,
                required: true
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                grupoLocal: {}
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.$emit('update:grupo', this.grupoLocal);
                    this.$emit('terminado');
                }
            }
        }
    }
</script>